/* eslint-disable react-hooks/exhaustive-deps */
import './CustomCard.css';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { IconButton, Menu, Tooltip } from '@mui/material';
import React, { FC, useEffect, useRef, useState } from 'react';
import { Icons } from '../../../assets/SvgIcons';
import { useNavigate, useParams } from 'react-router-dom';
import html2canvas from 'html2canvas';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import CameraIcon from '@mui/icons-material/Camera';
import moment from 'moment';
import ExcelExport from '../ExcelExport/ExcelExport';
import { ICExcelData } from '../../../helper/Interfaces';
import { useAppSelector } from '@Store/hooks';
import { getSound } from '@Store/feature/assetsSlice';

type CustomCardProps = {
  title: string;
  subTitle?: string;
  onCardLoaded?: () => any;
  screenShot?: boolean;
  className?: string;
  tooltip?: string;
  content: React.ReactNode;
  titleIcon?: React.ReactNode;
  hideBorderTitleIcon?: boolean;
  moreIcon?: boolean;
  excelType?: string;
  overFlow?: boolean;
  autoHeight?: boolean;
  headerButton?: React.ReactNode;
};

const CustomCard: FC<CustomCardProps> = ({
  title,
  subTitle,
  className,
  titleIcon,
  hideBorderTitleIcon,
  tooltip,
  onCardLoaded,
  moreIcon,
  content,
  screenShot,
  excelType,
  overFlow,
  autoHeight,
  headerButton,
}) => {
  let navigate = useNavigate();
  let { id } = useParams();
  const canvasRef = useRef<HTMLDivElement>(null);
  const [cameraLoading, setCameraLoading] = useState<boolean>(false);
  const sound = useAppSelector(getSound);
  const audio = new Audio(sound);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const openMoreMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const closeMoreMenu = () => {
    setAnchorEl(null);
  };

  const printDocument = (domElement: any, name: string) => {
    html2canvas(domElement).then(canvas => {
      setCameraLoading(true);
      //document.body.appendChild(canvas);
      console.log(canvas);
      audio.play();
      const link = document.createElement('a');
      link.download = `${name}-${moment().format('YYYY-MM-DD-HH-mm-ss')}.png`;
      link.href = canvas.toDataURL();

      setTimeout(() => {
        setCameraLoading(false);
        link.click();
        audio.pause();
      }, 700);
    });
  };
  useEffect(() => {
    onCardLoaded && onCardLoaded();
  }, []);

  return (
    <div ref={canvasRef} className={`custom-card card-height ${className}`}>
      <div className="custom-card-header">
        <div className="custom-card-header-left">
          {titleIcon && (
            <>
              {hideBorderTitleIcon ? (
                <div className="custom-card-header-left-icon hide-border">
                  {titleIcon}
                </div>
              ) : (
                <div className="custom-card-header-left-icon">{titleIcon}</div>
              )}
            </>
          )}

          <div className="card-title-content">
            <div className="card-title">
              <div className="card-title-span">{title}</div>

              {tooltip && (
                <div
                  style={{
                    position: 'relative',
                  }}
                >
                  <Tooltip title={tooltip}>
                    <IconButton className="tooltip-button">
                      <Icons.HelpOutline />
                    </IconButton>
                  </Tooltip>
                </div>
              )}
            </div>
            {subTitle && (
              <div
                style={{
                  cursor: subTitle.includes('milestone progress')
                    ? 'pointer'
                    : 'auto',
                }}
                className="card-subtitle"
                onClick={() => {
                  if (subTitle.includes('milestone progress'))
                    navigate('../milestone/' + id);
                }}
              ></div>
            )}
          </div>
        </div>
        <div className="custom-card-header-right">
          {moreIcon && (
            <>
              <IconButton size="small" onClick={openMoreMenu}>
                <MoreHorizIcon />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={closeMoreMenu}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                PaperProps={{
                  style: {
                    background: '#ffffff',
                    border: ' 1px solid #ebebf0',
                    boxSizing: 'border-box',
                    boxShadow: ' 0px 8px 16px rgba(0, 0, 0, 0.1)',
                    borderRadius: 4,
                    padding: '8px 8px 6px',
                  },
                }}
              >
                <ExcelExport type={excelType} id={id} />
              </Menu>
            </>
          )}
          {headerButton && headerButton}
          {screenShot && (
            <IconButton
              size="small"
              onClick={() => printDocument(canvasRef.current, title)}
            >
              {cameraLoading ? <CameraIcon /> : <PhotoCameraIcon />}
            </IconButton>
          )}
        </div>
      </div>
      <div
        className="custom-card-content customScroll"
        style={{
          // maxHeight: autoHeight ? 450 : 320,
          overflow: overFlow ? 'auto' : 'visible',
        }}
      >
        {content}
      </div>
    </div>
  );
};

export default CustomCard;
